(function () {
    'use strict';

    var module = angular.module('uwAgenda.agenda');
    module.controller('DaySchemeTimeEditModalController', [        
        '$uibModalInstance',
        'AgendaLabelService',
        'modalData',
        DaySchemeTimeEditModalController]
    );
    
    function DaySchemeTimeEditModalController(
        $uibModalInstance, 
        AgendaLabelService, 
        modalData) {
    
        var vm = this;
        vm.date = modalData.date;

        vm.dateFormatted = moment(vm.date).format('dddd LL');
        vm.timeFormatted = moment(vm.date).format('LT');
        
        AgendaLabelService.query(modalData.agendaId, false)
                .then(function(labels) {
                    vm.agendaLabels = labels.filter(function(label) {
                        return label.id !== modalData.currentLabelId && 
                               label.id !== 1; 
                    });
                    if (vm.agendaLabels.length > 0) {
                        vm.agendaLabel = vm.agendaLabels[0];
                    }
                });
        
        vm.cancel = function () {
            $uibModalInstance.dismiss();
        };

        vm.changeLabel = function () {
            $uibModalInstance.close(vm.agendaLabel.id);
        };
    }
})();
